import Icon from '../components/Icon.vue'

Icon.register({
  synagogue: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M70 196.5L6.7 268.3A26.6-26.6 0 0 1 0 285.9V512H128V239.6L90 196.5C84.7 190.5 75.3 190.5 70 196.5zM633.3 268.3L570 196.5C564.7 190.5 555.3 190.5 550 196.5L512 239.6V512H640V285.9C640 279.4 637.6 273.2 633.3 268.3zM340 7C328.3-2.3 311.7-2.3 300 7L172 109.4A32-32 0 0 1 160 134.4V512H256V419.4C256 387.6 277.8 358 309.3 352.9 349.3 346.4 384 377.1 384 416V512H480V134.4C480 124.7 475.6 115.5 468 109.4L340 7zM392.1 222.6C394 225.7 391.8 229.8 388.1 229.8H349.1L324 269.8C322.1 272.7 317.9 272.7 316 269.8L290.9 229.8H251.9C248.2 229.8 246 225.7 247.9 222.6L267.1 192 247.9 161.4C246 158.3 248.2 154.2 251.9 154.2H290.9L316 114.2C317.9 111.3 322.1 111.3 324 114.2L349.1 154.2H388.1C391.8 154.2 394.1 158.3 392.1 161.4L372.9 192 392.1 222.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/synagogue.js
// module id = 6YYA
// module chunks = 144